// export const environment = {
//   production: false,
//   APIEndpoint: 'https://apis.ifanow.com/futurewise/api/v1/web/',
//   mfProject: 'https://dev.ifanow.in/mutualfund/api/v1/web/',
//   // APIEndpoint: 'https://futurewise.my-planner.in/futurewise/api/v1/web/',
//   GmailAPIEndpoint: 'https://emailserver.my-planner.in/email-server/api/v1/web/',
//   TransactionPlatform: 'https://dev.ifanow.in/transaction-platform/api/v1/web/',
//   GoalPlatform: 'https://dev.ifanow.in/goal/api/v1/web/',
//   PostalUrl: 'https://api.postalpincode.in/pincode/',
//   UserUrl: 'https://apis.ifanow.com/userserver/api/v1/web/',
//   MarketPlaceUrl: 'https://dev.ifanow.in/marketplace-server/api/v1/web/',
//   RM: 'https://dev.ifanow.in/email-server/api/v1/web/',
//   LocalEndPoint: 'https://apis.ifanow.com/userserver/api/v1/web/user/',
//   LocalDevEndPoint: 'https://apis.ifanow.com/userserver/api/v1/web/user/',
//   PricingTest: 'https://apis.ifanow.com/userserver/api/v1/web/',
//   hmr: false,
// };

// export const environment = {
//   production: false,
//   APIEndpoint: 'https://dev.ifanow.in/futurewise/api/v1/web/',
//   mfProject: 'https://dev.ifanow.in/mutualfund/api/v1/web/',
//   // APIEndpoint: 'https://futurewise.my-planner.in/futurewise/api/v1/web/',
//   GmailAPIEndpoint: 'https://emailserver.my-planner.in/email-server/api/v1/web/',
//   TransactionPlatform: 'https://dev.ifanow.in/transaction-platform/api/v1/web/',
//   GoalPlatform: 'https://dev.ifanow.in/goal/api/v1/web/',
//   PostalUrl: 'https://api.postalpincode.in/pincode/',
//   UserUrl: 'https://dev.ifanow.in/userserver/api/v2/web/',
//   MarketPlaceUrl: 'https://dev.ifanow.in/marketplace-server/api/v1/web/',
//   RM: 'https://dev.ifanow.in/email-server/api/v1/web/',
//   LocalEndPoint: 'https://apis.ifanow.com/userserver/api/v2/web/user/',
//   LocalDevEndPoint: 'https://dev.ifanow.in/userserver/api/v2/web/user/',
//   PricingTest: 'https://dev.ifanow.com/userserver/api/v1/web/',
//   hmr: false,
// };

// export const environment = {
//   production: false,
//   APIEndpoint: 'https://staging.ifanow.in/futurewise/api/v1/web/',
//   mfProject: 'https://staging.ifanow.in/mutualfund/api/v1/web/',
//   // APIEndpoint: 'https://futurewise.my-planner.in/futurewise/api/v1/web/',
//   GmailAPIEndpoint: 'https://emailserver.my-planner.in/email-server/api/v1/web/',
//   TransactionPlatform: 'https://staging.ifanow.in/transaction-platform/api/v1/web/',
//   GoalPlatform: 'https://staging.ifanow.in/goal/api/v1/web/',
//   PostalUrl: 'https://staging.postalpincode.in/pincode/',
//   UserUrl: 'https://staging.ifanow.in/userserver/api/v1/web/',
//   MarketPlaceUrl: 'https://staging.ifanow.in/marketplace-server/api/v1/web/',
//   RM: 'https://staging.ifanow.in/email-server/api/v1/web/',
//   LocalEndPoint: 'https://apis.ifanow.com/userserver/api/v1/web/user/',
//   LocalDevEndPoint: 'https://staging.ifanow.in/userserver/api/v1/web/user/',
//   PricingTest: 'https://staging.ifanow.in/userserver/api/v1/web/',
//   hmr: false,
// };

export const environment = {
  production: false,
  APIEndpoint: 'https://apis.ifanow.com/futurewise/api/v1/web/',
  mfProject: 'https://apis.ifanow.com/mutualfund/api/v1/web/',
  // APIEndpoint: 'https://futurewise.my-planner.in/futurewise/api/v1/web/',
  GmailAPIEndpoint: 'https://emailserver.my-planner.in/email-server/api/v1/web/',
  TransactionPlatform: 'https://apis.ifanow.com/transaction-platform/api/v1/web/',
  GoalPlatform: 'https://apis.ifanow.com/goal/api/v1/web/',
  PostalUrl: 'https://api.postalpincode.in/pincode/',
  UserUrl: 'https://apis.ifanow.com/userserver/api/v1/web/',
  MarketPlaceUrl: 'https://dev.ifanow.in/marketplace-server/api/v1/web/',
  RM: 'https://apis.ifanow.com/email-server/api/v1/1/',
  LocalEndPoint: 'https://apis.ifanow.com/userserver/api/v1/web/user/',
  LocalDevEndPoint: 'https://dev.ifanow.in/userserver/api/v1/web/user/',
  PricingTest: 'https://apis.ifanow.in/userserver/api/v1/web/',
  hmr: false,
};


